import { useI18n } from "../../../../hooks/i18n/i18n";

export const useThis = () => {
  const ulAriaLabel = useI18n().t("search.goodsSearchResultListLabel");

  return { ulAriaLabel };
};
